module.exports = __webpack_public_path__ + "fonts/KFOmCnqEu92Fr1Mu72xKOzY.dd55ea0.woff2";